export default __webpack_public_path__ + "assets/ruleImage1Optimized.webp";